export interface User {
  id: string;
  login: string;
  name: string;
  surname: string;
  phone: string;
  password?: string;
}

export const userData: User[] = [
  {
    id: 'test1',
    login: 'demo',
    name: 'Benjamin',
    surname: 'Bergmann',
    phone: '0650 887 04 21',
    password: '098f6bcd4621d373cade4e832627b4f6',
  },
  {
    id: 'pass1',
    login: 'demo',
    name: 'Benjamin',
    surname: 'Bergmann',
    phone: '0650 887 04 21',
    password: '5f4dcc3b5aa765d61d8327deb882cf99',
  },
  {
    id: 'demo1',
    login: 'demo',
    name: 'Benjamin',
    surname: 'Bergmann',
    phone: '0650 887 04 21',
    password: 'fe01ce2a7fbac8fafaed7c982a04e229',
  },
];

export const userService = {
  getLogged() {
    const json = window.localStorage.getItem('logged');
    return json ? (JSON.parse(json) as User) : undefined;
  },

  checkValidation(login: string, password: string) {
    const users = userData.filter((element: User) => (element.login === login && element.password === password));
    if (users.length === 1) {
      delete users[0].password;
      window.localStorage.setItem('logged', JSON.stringify({ ...users[0] }));
      window.localStorage.removeItem('passwd');
      window.localStorage.removeItem('login');
      return true;
    }
    return false;
  },

};
